import { CookieBanner } from './components/CookieBanner.js';
import { FaqSection } from './components/FaqSection.js';
import { Features } from './components/Features.js';
import { Hero } from './components/Hero.js';
import { HowItWorks } from './components/HowItWorks.js';
import { RoadmapSection } from './components/RoadmapSection.js';
import { SiteFooter } from './components/SiteFooter.js';
import { SiteNav } from './components/SiteNav.js';
import { SuggestionSection } from './components/SuggestionSection.js';
import { useRoute } from './lib/route.js';
import { CookiesPage } from './pages/CookiesPage.js';
import { PrivacyPage } from './pages/PrivacyPage.js';
import { TermsPage } from './pages/TermsPage.js';
import { UpdatesPage } from './pages/UpdatesPage.js';

export default function App() {
  const path = useRoute();

  return (
    <>
      {renderPage(path)}
      <CookieBanner />
    </>
  );
}

function renderPage(path: ReturnType<typeof useRoute>) {
  switch (path) {
    case '/privacidade':
      return <PrivacyPage />;
    case '/termos':
      return <TermsPage />;
    case '/cookies':
      return <CookiesPage />;
    case '/atualizacoes':
      return <UpdatesPage />;
    default:
      return <HomePage />;
  }
}

function HomePage() {
  return (
    <>
      <SiteNav />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <RoadmapSection />
        <FaqSection />
        <SuggestionSection />
      </main>
      <SiteFooter />
    </>
  );
}
